import { Box, FlexColumn, FlexRow, TextField } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import css from "./CustomViewOptions.module.css";
import PropertyCustomViewOptionsStore from "./PropertyCustomViewOptionsStore";

const PrintOptionImageGalleryHeightAndWidth: FunctionComponent = observer(function PrintOptionImageGalleryHeightAndWidth() {
	const { optionsStore } = useCustomViewDialogStore();
	const loc = useLocale();

	const {
		onBlurPrintImageHeight,
		onBlurPrintImageWidth,
		options,
		setPrintImageHeight,
		setPrintImageWidth,
	} = optionsStore as PropertyCustomViewOptionsStore;

	const {
		displayPropertyImage,
		propertyImageHeight,
		propertyImageWidth,
	} = options;

	return (
		<>
			{displayPropertyImage && (
				<Box 
					className={css.container}
					data-csi-automation="PrintOptionImageGalleryHeightAndWidth"
				>
					<FlexRow>
						<FlexColumn 
							className={css.optionLeft}
							data-csi-automation="CustomViewPrintImageWidth"
						>
							<TextField
								fullWidth
								onBlur={onBlurPrintImageWidth}
								onChange={setPrintImageWidth}
								placeholderRes="Default"
								res="CustomViewPrintImageWidth"
								value={propertyImageWidth || ""}
							/>
						</FlexColumn>
						<FlexColumn 
							className={css.optionRightSelect}
							data-csi-automation="CustomViewPrintImageHeight"
						>
							<TextField
								fullWidth
								onBlur={onBlurPrintImageHeight}
								onChange={setPrintImageHeight}
								placeholderRes="Default"
								res="CustomViewPrintImageHeight"
								value={propertyImageHeight || ""}
							/>
						</FlexColumn>
					</FlexRow>
				</Box>
			)}
		</>
	);
});

export default PrintOptionImageGalleryHeightAndWidth;